// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"18334cd5","453":"ab41c974"}[chunkId] + ".chunk.js";
};